module.exports = __webpack_public_path__ + "img/harsh-acceleration.c99ee95a.svg";